import { type StatusChipVariant } from '@/components/ui/status-chip';

export interface EvmThreshold {
  label: string;
  dotClassName: string;
  variant: StatusChipVariant;
}

export function getEvmThreshold(score: number): EvmThreshold {
  if (score >= 8)
    return {
      label: 'Healthy',
      dotClassName: 'bg-chariot-stroke-info',
      variant: 'info',
    };
  if (score >= 6)
    return {
      label: 'Monitor',
      dotClassName: 'bg-chariot-stroke-medium',
      variant: 'high',
    };
  if (score >= 4)
    return {
      label: 'At Risk',
      dotClassName: 'bg-chariot-stroke-high',
      variant: 'critical',
    };
  return {
    label: 'Critical',
    dotClassName: 'bg-chariot-stroke-critical',
    variant: 'critical',
  };
}
